import comments from 'mk2/apps/blogs/containers/Comments/Comments.sagas';
import likeInfoPopupSagas from 'mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup.sagas';
import userStrollersSagas from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.sagas';
import { all, fork } from 'redux-saga/effects';

export default function* root() {
    yield all([
        fork(comments),
        fork(likeInfoPopupSagas),
        fork(userStrollersSagas),
    ]);
}
